import React, { useState } from "react";
import { T, MINI_CRIS_SRC } from "./theme";

const GoldSymbol = () => (
  <div className="flex h-20 w-20 items-center justify-center rounded-full" data-testid="mini-cris-fallback"
    style={{ background: "rgba(255,255,255,0.08)", border: "1px solid rgba(227,201,154,0.45)" }}>
    <img src="/cliente-icons/symbol-gold.png" alt="" aria-hidden="true" className="h-12 w-auto" draggable="false" />
  </div>
);

// Mostra o arquivo oficial so depois de carregado e decodificado; ausente/corrompido => simbolo dourado.
const MiniCris = () => {
  const [state, setState] = useState("loading");
  if (state === "error") return <GoldSymbol />;
  return (
    <>
      {state === "loading" && <GoldSymbol />}
      <img src={MINI_CRIS_SRC} alt="Mini Cris" draggable="false" data-testid="mini-cris-official"
        className={state === "ok" ? "h-28 w-auto drop-shadow-xl" : "hidden"}
        onLoad={(e) => setState(e.currentTarget.naturalWidth > 0 ? "ok" : "error")} onError={() => setState("error")} />
    </>
  );
};

const MSG = {
  late: "Vamos colocar seus compromissos em ordem? Você pode reconstruir seu histórico com novos pagamentos pontuais.",
  soon: "Seu próximo compromisso está chegando! Que tal garantir mais um pagamento em dia?",
  good: "Você está indo muito bem! 💜 Continue mantendo suas parcelas em dia e fortalecendo seu histórico!",
  new: "Seja bem-vinda! Cada pagamento em dia ajuda a construir o seu histórico.",
};

export const ScoreHero = ({ mood }) => (
  <header className="relative w-full overflow-hidden rounded-b-[32px] pb-28 text-white" data-testid="score-hero"
    style={{ background: "linear-gradient(155deg, #5B23A3 0%, #45198A 45%, #2A0E4F 100%)", paddingTop: "calc(1rem + env(safe-area-inset-top))" }}>
    <div aria-hidden="true" className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full" style={{ background: "radial-gradient(circle, rgba(201,164,92,0.28), transparent 70%)" }} />
    <div className="relative mx-auto w-full max-w-2xl px-5">
      <div className="flex items-center gap-3">
        <img src="/cliente-icons/symbol-gold.png" alt="" aria-hidden="true" className="h-10 w-auto" draggable="false" />
        <div className="leading-none">
          <div className="text-[20px] font-semibold">Cris Cliente</div>
          <div className="mt-1 whitespace-nowrap text-[8px] font-bold uppercase tracking-[0.18em] text-[#E3C99A]">Banco das Revendedoras</div>
        </div>
        <span className="ml-auto whitespace-nowrap rounded-full border px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.2em]"
          style={{ borderColor: "rgba(227,201,154,0.6)", color: "#E3C99A" }} data-testid="score-hero-badge">CRIS CREDIT</span>
      </div>
      <div className="mt-6 flex items-end gap-3">
        <div className="min-w-0 flex-1">
          <h1 className="text-[28px] font-extrabold leading-[1.1] tracking-[-0.01em] sm:text-[34px]" data-testid="score-hero-title">
            Sua confiança <span style={{ color: "#E3C99A" }}>abre portas</span>
          </h1>
          <p className="mt-2 text-[15px] leading-snug text-white/85">Pague em dia, fortaleça seu histórico e conquiste novas oportunidades.</p>
        </div>
        <div className="relative shrink-0" data-testid="mini-cris">
          <MiniCris />
        </div>
      </div>
      <div className="cc-pop relative mt-4 rounded-2xl rounded-tr-sm px-4 py-3 text-[14px] leading-snug shadow-lg" role="status"
        style={{ background: "#FFFFFF", color: T.deep }} data-testid={`mini-cris-message-${mood}`}>
        {MSG[mood] || MSG.new}
      </div>
    </div>
  </header>
);
